module.exports = __webpack_public_path__ + "images/icon-member-remove.d593d380f1af40571ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-member-remove.svg
// module id = AbRh
// module chunks = 24